const physicalExamination = () => import('@/views/web/physicalExamination');
const choosePkg = () => import('@/views/web/choosePkg');
const chooseKxPkg = () => import('@/views/web/chooseKxPkg');
const chooseAudioPkg = () => import('@/views/web/chooseAudioPkg');
const confirmPkg = () => import('@/views/web/confirmPkg');
const settleAccounts = () => import('@/views/web/settleAccounts');
const noticeDetail = () => import('@/views/web/noticeDetail')
const INDEX = () => import('@/views/web/index');
const FAMILY = () => import('@/views/web/family');
const LOGIN = () => import('@/views/web/login');
const DETAIL = () => import('@/views/web/detail');
const APPOINTMENT = () => import('@/views/web/appointment');
const appointmentAgain = () => import('@/views/web/appointmentAgain');

const RESERVE_DETAIL = () => import('@/views/web/reserveDetail');
const RESULT = () => import('@/views/web/result');
const REPORT = () => import('@/views/web/report');
const REPORT_PDF = () => import('@/views/web/report_pdf');
const ReportList = () => import('@/views/web/reportList')
const SSO = () => import('@/views/web/sso');
const bindLogin = () => import('@/views/web/bindLogin');
const BINDPHONE = () => import('@/views/web/bindphone');
const SURVEY = () => import('@/views/web/survey');
const FEEDBACK = () => import('@/views/web/feedback');
const ORDERDETAIL = () => import('@/views/web/orderDetail');

const groupAppointment = () => import('@/views/web/group_appointment');

const reimbursement = () => import('@/views/web/reimbursement');
const reimbursementAdd = () => import('@/views/web/reimbursementAdd');
const reimbursementDetail = () => import('@/views/web/reimbursementDetail');
const confirmExaminee = () => import('@/views/web/confirmExaminee');
const payMiddlePage = () => import('@/views/web/payMiddlePage');
const basePath = '/hms/web';
export default [
  // 首页
  {
    path: basePath + '/index',
    name: 'index',
    component: INDEX,
    meta: {
      title: '首页'
    }
  },
  // 确认套餐
  {
    path: basePath + '/confirmPkg',
    name: 'confirmPkg',
    component: confirmPkg,
    meta: {
      title: '确认套餐'
    }
  },
  // 确认体检人信息
  {
    path: basePath + '/confirmExaminee',
    name: 'confirmExaminee',
    component: confirmExaminee,
    meta: {
      title: '确认体检人信息'
    }
  },
  // 支付回调页
  {
    path: basePath + '/payMiddlePage',
    name: 'payMiddlePage',
    component: payMiddlePage,
    meta: {
      title: '支付回调页'
    }
  },
  // 系统公告
  {
    path: basePath + '/noticeDetail',
    name: 'noticeDetail',
    component: noticeDetail,
    meta: {
      title: '系统公告'
    }
  },
  // 支付
  {
    path: basePath + '/settleAccounts',
    name: 'settleAccounts',
    component: settleAccounts,
    meta: {
      title: '支付'
    }
  },
  // 选择加项目包
  {
    path: basePath + '/choosePkg',
    name: 'choosePkg',
    component: choosePkg,
    meta: {
      title: '加项包'
    }
  },
  // 选择加项目包
  {
    path: basePath + '/chooseKxPkg',
    name: 'chooseKxPkg',
    component: chooseKxPkg,
    meta: {
      title: '自选加项包'
    }
  },
  // 选择语音加项目包
  {
    path: basePath + '/chooseAudioPkg',
    name: 'chooseAudioPkg',
    component: chooseAudioPkg,
    meta: {
      title: '语音加项包'
    }
  },
  // 体检须知
  {
    path: basePath + '/physicalExamination',
    name: 'physicalExamination',
    component: physicalExamination,
    meta: {
      title: '体检须知'
    }
  },
  // 家属套餐列表页
  {
    path: basePath + '/family',
    name: 'family',
    component: FAMILY,
    meta: {
      title: '套餐列表'
    }
  },
  //登录页
  {
    path: basePath + '/login',
    name: 'login',
    component: LOGIN,
    meta: {
      title: '登录页'
    }
  },
  //套餐详情页
  {
    path: basePath + '/detail',
    name: 'detail',
    component: DETAIL,
    meta: {
      title: '详情'
    }
  },
  // 历年报告列表页
  {
    path: basePath + '/report_list',
    name: 'reportList',
    component: ReportList,
    meta: {
      title: '历年报告'
    }
  },
  // 预约页
  {
    path: basePath + '/appointment',
    name: 'webAppointment',
    component: APPOINTMENT,
    meta: {
      title: '预约'
    }
  },
   // 重新预约页
   {
    path: basePath + '/appointmentAgain',
    name: 'webAppointmentAgain',
    component: appointmentAgain,
    meta: {
      title: '预约'
    }
  },
    // 团检预约页
    {
      path: basePath + '/group_appointment',
      name: 'webGroupAppointment',
      component: groupAppointment,
      meta: {
        title: '预约'
      }
    },
  // 满意度调查问卷
  {
    path: basePath + '/survey',
    name: 'survey',
    component: SURVEY,
    meta: {
      title: '满意度调查'
    }
  },
  // 我要反馈
  {
    path: basePath + '/feedback',
    name: 'feedback',
    component: FEEDBACK,
    meta: {
      title: '我要反馈'
    }
  },
  //预约详情
  {
    path: basePath + '/reserve_detail',
    name: 'webReserveDetail',
    component: RESERVE_DETAIL,
    meta: {
      title: '预约详情'
    }
  },
  //支付结果页
  {
    path: basePath + '/result',
    name: 'result',
    component: RESULT,
    meta: {
      title: '结果页'
    }
  },
  //报告页
  {
    path: basePath + '/report',
    name: 'report',
    component: REPORT,
    meta: {
      title: '报告页'
    }
  },
  //pdf报告页
  {
    path: basePath + '/report_pdf',
    name: 'report_pdf',
    component: REPORT_PDF,
    meta: {
      title: '报告页'
    }
  },
  //验签
  {
    path: basePath + '/sso/index',
    name: 'sso',
    component: SSO,
    meta: {
      title: '验签'
    }
  },
  //绑定登录态
  {
    path: basePath + '/user/bind_login',
    name: 'bind_login',
    component: bindLogin,
  },
  //绑定手机页
  {
    path: basePath + '/bindphone',
    name: 'bindPhone',
    component: BINDPHONE,
    meta: {
      title: '绑定手机号'
    }
  },
  // 订单详情页
  {
    path: basePath + '/orderDetail',
    name: 'orderDetail',
    component: ORDERDETAIL,
    meta: {
      title: '订单详情'
    }
  },
  // 线上报销
  {
    path: basePath + '/reimbursement',
    name: 'reimbursement',
    component: reimbursement,
    meta: {
      title: '体检线上报销'
    }
  },
  // 添加线上报销
  {
    path: basePath + '/reimbursementAdd',
    name: 'reimbursementAdd',
    component: reimbursementAdd,
    meta: {
      title: '体检线上报销'
    }
  },
  // 线上报销详情
  {
    path: basePath + '/reimbursementDetail',
    name: 'reimbursementDetail',
    component: reimbursementDetail,
    meta: {
      title: '体检线上报销详情'
    }
  }
]
